import { Component, Vue } from 'vue-property-decorator';
import WithRender from  './productDetail.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';

@WithRender
@Component({
  components: {
    Loading,
  },
})
export default class ProductDetail extends Vue {
  items = [];
  fields = [
    {
      key: "name",
      label: "Product"
    },
    {
      key: "agentFeeFixed",
      label: "Fixed Amount Discount",
    },
    {
      key: "agentFeePercentage",
      label: "Percentage Discount",
    }
  ]

  mounted () {
    this.getProductDiscounts();
   }  

  getProductDiscounts():void
  {
    _axios.get(`${config.gateway}payment/Product/ProductDiscounts`)
    .then(response=>
    {
      this.items = response.data;
    })
    .catch(err=>{console.error(err);});
  }
}
